import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The Pinnacle of Immersive",
    text: "COLAB Theatre is called the best immersive theatre in London by the critics who cover it. \u201CA byword for quality in immersive theatre,\u201D said Soaked in Dreams. \u201CThe peak of immersive theatre,\u201D said The Crumb. Fourteen years of raves say the same thing.",
    tag: "The Verdict",
  },
  {
    num: "02",
    title: "The COLAB Method",
    text: "We don\u2019t stage shows \u2014 we build worlds you walk into. Every COLAB production is a working city: characters with motives, locations with secrets, actors improvising around your choices. That\u2019s why the immersive theatre press keeps calling us the best.",
    tag: "How We Work",
  },
  {
    num: "03",
    title: "The Archive",
    text: "Fifteen productions from Fifth Column (2014) to The End (2026). Sixty-five verified press reviews. Twenty-four raves. Fourteen five-star notices. Thirty-nine outlets. One London immersive theatre company. This is the archive of the best.",
    tag: "By the Numbers",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="home-manifesto"
      className="section relative bg-[#050505]"
    >
      {/* Top rule w/ label */}
      <div className="px-6 md:px-14 lg:px-20 xl:px-24 flex items-center justify-between mb-20 md:mb-32">
        <div className="text-[10px] uppercase tracking-[0.35em] font-mono text-white/50">
          Why COLAB Is the Best Immersive Theatre in London
        </div>
        <div className="text-[10px] uppercase tracking-[0.35em] font-mono text-white/30 hidden md:block">
          Best Immersive Theatre · London · Since 2011
        </div>
      </div>

      <div className="px-6 md:px-14 lg:px-20 xl:px-24">
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          className="bleed-h max-w-5xl text-white mb-24 md:mb-40"
        >
          Best immersive theatre reviews in London.
          <span className="block text-white/40">The critics&apos; verdict.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-y-40">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              variants={fadeUp}
              custom={i}
              data-testid={`manifesto-chapter-${c.num}`}
              className={`relative ${
                i % 2 === 0
                  ? "md:col-span-8"
                  : "md:col-span-8 md:col-start-5"
              }`}
            >
              <div className="chapter-num absolute -top-14 md:-top-24 -left-4 md:left-[-40px] z-0 select-none">
                {c.num}
              </div>
              <div className="relative z-10 pl-2 md:pl-16 border-l border-white/10">
                <div className="text-[10px] uppercase tracking-[0.35em] font-mono text-[#8b0000] mb-6">
                  Chapter {c.num} · {c.tag}
                </div>
                <h3 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight uppercase mb-8">
                  {c.title}
                </h3>
                <p className="text-white/70 text-lg md:text-xl leading-relaxed max-w-2xl">
                  {c.text}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
